module.exports = __webpack_public_path__ + "img/64_10.8a802782.png";